import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";

export default function ButtonWhite({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#fff',
          colorText: '#384146',
        },
      }}
    >
      <Button type={"primary"} {...props} style={{color: '#384146'}}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
